import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Opening Day
import HomeOpeningDay from "./views/openingDay/Home";
import ConfirmationOpeningDay from "./views/openingDay/Step10_Confirmation";

// Day of Open Doors
import HomeDayOfOpenDoors from "./views/dayOfOpenDoors/Home";
import TicketDayOfOpenDoors from "./views/dayOfOpenDoors/Step10_Ticket";
import ParticipantDayOfOpenDoors from "./views/dayOfOpenDoors/Step20_Participant";
import ConfirmationDayOfOpenDoors from "./views/dayOfOpenDoors/Step30_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";
import "./css/footer.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<PageNotFound />} />

                {/* Opening Day */}
                <Route path="/:language/opening-day" element={<HomeOpeningDay />} />
                <Route path="/:language/opening-day/confirmation/:orderId" element={<ConfirmationOpeningDay />} />  

                {/* Day of Open Doors */}
                <Route path="/:language/day-of-open-doors" element={<HomeDayOfOpenDoors />} />
                <Route path="/:language/day-of-open-doors/ticket" element={<TicketDayOfOpenDoors />} />
                <Route path="/:language/day-of-open-doors/participant" element={<ParticipantDayOfOpenDoors />} />
                <Route path="/:language/day-of-open-doors/confirmation/:orderId" element={<ConfirmationDayOfOpenDoors />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
